<template>
  <div class="prize-wrapper">
    <div class="wtop-box">
      <img src="@/assets/image/bg.png" alt="" class="bgImg">
<!--      <div class="wt-order">-->
<!--        <img src="@/assets/image/i_order.png" alt="">-->
<!--        <div>我的订单</div>-->
<!--      </div>-->
      <div class="wheel-box">
        <img src="@/assets/image/w-bottom.png" alt="" class="wbImg">
        <div class="wheel-wrapper">
          <div
            class="wheel-pointer"
            @click="startCallBack"
          >
            <div class="wp-inner">
              <img src="@/assets/image/arrow.png" alt="">
              <img src="@/assets/image/i_start.png" alt="" class="wp-start">
              <div class="hand-box">
                <img src="@/assets/icon_hand.png" alt="" class="h-icon">
              </div>
            </div>
          </div>
          <div
            class="wheel-bg"
            :class="{freeze: freeze}"
            :style="`transform: rotate(${wheelDeg}deg);`"
          >
            <div class="prize-list">
              <div
                class="prize-item-wrapper"
                :class="'mm' + index"
                v-for="(item,index) in prizeList"
                :key="index"
                :style="`transform: rotate(-${wheelDeg}deg)`"
              >
                <!--            :style="`transform: rotate(${(-45) * index}deg)`"-->
                <div
                  class="prize-item"
                >
                  <div class="prize-name">
                    <!--                {{ item.name }}-->
                    <img src="@/assets/image/i_market.png" alt="">
                    <img :src="item.image" class="pImg">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
<!--        <div class="wheel-inner">-->
<!--          <LuckyWheel-->
<!--            class="luck-draw"-->
<!--            ref="LuckyWheel"-->
<!--            width="270"-->
<!--            height="270"-->
<!--            :blocks="blocks"-->
<!--            :prizes="prizes"-->
<!--            :buttons="buttons"-->
<!--            :default-style="defaultStyle"-->
<!--            :default-config="defaultConfig"-->
<!--            @start="startCallBack"-->
<!--            @end="endCallBack"-->
<!--          />-->
<!--        </div>-->
      </div>
    </div>
    <div class="wheel-tips">
      <div class="wt-inner">
        <div class="w-box">
          <div class="w-line">
            <div class="wl-top">
              <img src="@/assets/image/num_1.png" alt="" class="wlt-num">
              <img src="@/assets/image/i_love.png" alt="" class="wlt-love" v-if="isPay[0]===false">
              <img src="@/assets/image/i_alove.png" alt="" class="wlt-love" v-else>
              <div class="wlt-price" v-if="isPay[0]===false">支付<span v-if="payList.length>0">{{payList[0].salePrice}}</span>元预约</div>
              <div class="wlt-price" v-else>预约成功</div>
            </div>
            <div class="wl-btn" v-if="isPay[0]===false" @click="payOrder(0)">立即预约</div>
            <div class="wl-btn gray" v-else>已预约</div>
          </div>
          <div class="w-line">
            <div class="wl-top">
              <img src="@/assets/image/num_2.png" alt="" class="wlt-num">
              <img src="@/assets/image/i_love.png" alt="" class="wlt-love" v-if="isPay[1]===false">
              <img src="@/assets/image/i_alove.png" alt="" class="wlt-love" v-else>
              <div class="wlt-price" v-if="isPay[1]===false">支付<span v-if="payList.length>0">{{payList[1].salePrice}}</span>元搭乘</div>
              <div class="wlt-price" v-else>搭乘成功</div>
            </div>
            <div class="wl-btn" v-if="isPay[1]===false" @click="payOrder(1)">立即搭乘</div>
            <div class="wl-btn gray" v-else>已搭乘</div>
          </div>
        </div>
        <div class="w-tips">先预约再搭乘，请至少提前一天预约,<span>2颗</span>心全亮 即可<span>启动幸福摩天轮</span></div>
      </div>
    </div>
    <div class="wheel-rules">
      <div class="wr-title">～活动规则～</div>
      <div class="wr-content" v-html="rule">
<!--        <p>【活动时间】：即日起至2021年12月31日</p>-->
<!--        <p>【活动对象】：微信用户</p>-->
<!--        <p>【活动内容】：</p>-->
<!--        <p class="wrc-p">1、活动期间，微信用户点击“立即预约”和“立即搭乘”并使用一网通支付0.01元，即可领取现金红包1份，最高88元现金红包，数量有限，先到先得。</p>-->
<!--        <p class="wrc-p">2、“立即预约”和“立即搭乘”须在不同的两天完成，请至少提前一天预约，每位客户仅可领取一次奖励。</p>-->
<!--        <p class="wrc-p">3、用户首次使用一网通支付，需绑定一张银行卡（不限银行），第二次可立即支付。</p>-->
<!--        <p class="wrc-p">4、本活动解释权归招商银行无锡分行所有。如有疑问，请拨打客服热线：0510-85603389咨询，工作时间：9:00-18:00。</p>-->
<!--        <p>【领取礼品】：</p>-->
<!--        <p class="wrc-p">1、点击【开心收下后】，可前往【我的订单】-点击【立即使用】领取 </p>-->
<!--        <p class="wrc-p">2、领取成功后，请注意接收微信支付推送的消息</p>-->
<!--        <p class="wrc-p">3、点击微信支付消息，现金红包即可兑现到微信钱包</p>-->
      </div>
    </div>
<!--    <img src="@/assets/image/bg.png" alt="" class="p-bg">-->
<!--    <div class="prize-main-content">-->
<!--      <div class="p-m-title">-->
<!--        <span class="txt">-->
<!--          建行苏州分行特定用户可参与-->
<!--        </span>-->
<!--      </div>-->
<!--      <div class="p-box">-->
<!--        <img src="@/assets/image/pan.png" alt="" class="pan">-->
<!--        <div class="luck-wheel-box" ref="wheelBox">-->
<!--          <LuckyWheel-->
<!--            ref="LuckyWheel"-->
<!--            :width="wheelWidth"-->
<!--            :height="wheelWidth"-->
<!--            :prizes="prizes"-->
<!--            :default-style="defaultStyle"-->
<!--            :defaultConfig="defaultConfig"-->
<!--            :blocks="blocks"-->
<!--            :buttons="buttons"-->
<!--            @start="startCallBack"-->
<!--            @end="endCallBack"-->
<!--            v-if="wheelShow"-->
<!--          />-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="rule-box">-->
<!--        <div class="inner">-->
<!--          <div class="r-title">-->
<!--            <img src="@/assets/image/icon_gift.png" alt="" class="r-icon">-->
<!--            <span class="r-txt">活动细则</span>-->
<!--          </div>-->
<!--          <div class="r-content" v-html="rule">-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="prize-order-box" @click="goOrder">-->
<!--      <span class="txt">我的订单</span>-->
<!--    </div>-->
<!--    <div class="call">-->
<!--      <a href="tel:0512-66555556">-->
<!--        <img src="@/assets/avator.png" alt="">-->
<!--      </a>-->
<!--    </div>-->
    <div
      class="index-kefu"
      id="default_drag_comp2"
      @click="goNext2"
      @touchstart="down2"
      @touchmove="move2"
      @touchend="end2"
    >
      <img src="../assets/avator.png" alt="" @click="callPhone" />
    </div>
    <div
      class="index-order"
      id="default_drag_comp"
    >
      <img src="../assets/homemaking/indexorder.png" alt="" />
      <div @click.stop="pushMyOrder">我的订单</div>
    </div>
    <div class="call">
      <a @click.stop="serviceShow = true">
        <img src="@/assets/avator-red.png" alt="">
      </a>
    </div>
    <van-popup v-model="modalGetShow" class="get-modal">
      <div class="get-modal-box" v-if="lotteryItem">
        <img src="@/assets/image/bao_bg.png" alt="" class="get-bg">
        <img src="@/assets/image/label_bg.png" alt="" class="label-bg">
        <div class="get-modal-content">
          <div class="top">
            <div class="img-box">
              <img :src="lotteryItem.image" alt="" class="product">
            </div>
            <div class="top-title">
              <span class="txt">恭喜获得</span>
              <em class="price">{{lotteryItem.prizeName.split('元')[0]}}</em>
              <span class="txt">元{{lotteryItem.prizeName.split('元')[1]}}</span>
            </div>
            <div class="top-btn-box" @click.stop="getPrize">
              <div class="btn">确定</div>
              <img src="@/assets/image/icon_star.png" alt="" class="t-icon">
            </div>
          </div>
          <div class="info">
            <div class="info-title">{{lotteryItem.prizeName.split('元')[1]}}领取攻略：</div>
            <div class="info-txt" v-html="lotteryItem.useExplain">
            </div>
          </div>
        </div>
      </div>
      <div class="get-modal-close-box" @click="modalGetShow = false">
        <img src="@/assets/image/icon_close.png" alt="" class="close">
      </div>
    </van-popup>
    <van-popup v-model="modalFailShow" class="fail-modal">
      <div class="get-modal-box">
        <img src="@/assets/image/bao_mini_bg.png" alt="" class="get-bg">
        <img src="@/assets/image/label_mini_bg.png" alt="" class="label-bg">
        <div class="line"></div>
        <div class="get-modal-content">
          <div class="top">
            <div class="img-box">
              <img src="@/assets/image/icon_fail.png" alt="" class="product">
            </div>
            <div class="top-title">
              <span class="txt">很遗憾，请下次再来！</span>
            </div>
            <div class="top-btn-box" @click="modalFailShow = false">
              <div class="btn">失落的离开</div>
              <img src="@/assets/image/icon_star.png" alt="" class="t-icon">
            </div>
          </div>
        </div>
      </div>
      <div class="get-modal-close-box" @click="modalFailShow = false">
        <img src="@/assets/image/icon_close.png" alt="" class="close">
      </div>
    </van-popup>
<!--    <van-popup v-model="modalBillShow" class="bill-modal">-->
<!--      <div class="bill-modal-box">-->
<!--        <div class="bill-label">充值账号</div>-->
<!--        <div class="bill-input-box">-->
<!--          <input type="text" maxlength="11" placeholder="请输入您的手机号" class="bill-input" v-model="phone">-->
<!--        </div>-->
<!--        <div class="bill-mini-label">充值话费</div>-->
<!--        <div class="bill-money" v-if="lotteryItem">{{lotteryItem.prizeName.split('元')[0]}}元</div>-->
<!--        <div class="bill-btn-box">-->
<!--          <van-button type="info" round block color="#3a95e2" :loading="btnLoading" loading-text="充值中" @click="rechargePhone">确认充值</van-button>-->
<!--        </div>-->
<!--      </div>-->
<!--    </van-popup>-->
<!--    <div class="rule-box" @click.stop="ruleShow = true">-->
<!--      <img src="@/assets/homemaking/dp.png" alt="" class="r-icon">-->
<!--      <div class="r-txt">规则</div>-->
<!--    </div>-->
    <van-popup v-model="ruleShow" class="rule-modal">
      <div class="content" v-html="ruleTxt"></div>
    </van-popup>
    <van-popup v-model="serviceShow" class="rule-modal service-modal">
      <div class="service-list">
        <a class="service" href="tel:0512-66555556">
          <img src="@/assets/avator-red.png" alt="">客服哈哈~O(∩_∩)O
        </a>
        <a class="service" href="tel:18036395813">
          <img src="@/assets/avator-red.png" alt="">客服浩浩(๐•̆ ·̭ •̆๐)
        </a>
        <div class="service time">工作时间<br>
          <span class="title">9:00 ~ 17:00</span>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script src="//unpkg.com/vue/dist/vue.js"></script>
<script>
import { mapState } from 'vuex'
import { Activity,yyActivity,getApiUserOrderPage,Order, Pay,checkOrder, activityJoins,createLotteryOrder, getApiUserDetail, Lottery, Ljj, wxCashCoupon, getApiUserOrderDetail, useOrderProduct, useOrderProductDetail } from '@/api/api.js'
export default {
  computed: {
    ...mapState(['userInfo']),
    prizeList () {
      return this.prizeListOrigin.slice(0, this.prizeNumber)
    }
  },
  data () {
    return {
      buttons: [{
        radius: '40px',
        imgs: [
          { src: require('../assets/image/arrow.png'), width: '105%', top: '-140%' },
          { src: require('../assets/image/i_start.png'), width: '55%', top: '-20%' }]
      }],
      blocks: [{
        imgs: [
          { src: require('../assets/image/w-border.png'), width: '100%',rotate: true}
          ]
      }
      ],
      defaultStyle: {
        fontColor: '#303133',
        fontSize: '10px',
      },
      defaultConfig: {
        gutter: '1px',
        stopRange: '0'
      },
      list: [],
      rule: '',
      hasLottery: false,
      productId: '',
      currentIndex: 0,
      lotteryItem: '',
      orderDetails: '',
      phone: '',
      btnLoading: false,
      payList: [],
      isPay: [false,false],
      joinTimes: 0,
      modalFailShow: false,
      modalGetShow: false,
      prizeMsg: '',
      starting: false,
      flags: false,
      position: { x: 0, y: 0 },
      nx: "",
      ny: "",
      dx: "",
      dy: "",
      xPum: "",
      yPum: "",
      flags2: false,
      position2: { x: 0, y: 0 },
      nx2: "",
      ny2: "",
      dx2: "",
      dy2: "",
      xPum2: "",
      yPum2: "",
      tabNum: 0,
      shopList: [],
      allData: [],
      ruleShow: false,
      serviceShow: false,
      ruleTxt: '',
      freeze: false,
      rolling: false,
      wheelDeg: 0,
      prizeNumber: 6,
      prizeListOrigin: [],
      nowTime: '',
      payStepList: []
    }
  },
  created () {
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    if (month < 10) {
      month = '0' + month;
    }
    if (day < 10) {
      day = '0' + day;
    }
    this.nowTime = year + '-' + month + '-' + day;
  },
  mounted () {
    // this.getPrizesList()
    this.getLogin()
  },
  watch: {
    prizeNumber () {
      this.freeze = true
      this.wheelDeg = 0

      setTimeout(() => {
        this.freeze = false
      }, 0)
    }
  },
  methods: {
    onClickRotate(r) {
      if (this.rolling) {
        return;
      }
      this.rolling = true;
      const { wheelDeg, prizeList } = this;
      // const random = Math.floor(Math.random() * (prizeList.length ));
      const random = r;
      console.log(random);
      this.wheelDeg =
        wheelDeg -
        wheelDeg % 360 +
        2 * 360 +
        (360 - 360 / prizeList.length * random);
      setTimeout(() => {
        this.rolling = false;
        // alert("Result：" + prizeList[random].prizeName);
        this.endCallBack ()
      }, 4500);
    },
    goNext() {
      this.$emit("goNext");
    },
    // 实现移动端拖拽
    down() {
      let default_drag_comp = document.querySelector("#default_drag_comp");
      this.flags = true;
      var touch;
      if (event.touches) {
        touch = event.touches[0];
      } else {
        touch = event;
      }
      this.maxW = document.body.clientWidth - default_drag_comp.offsetWidth;
      this.maxH = document.body.clientHeight - default_drag_comp.offsetHeight;

      this.position.x = touch.clientX - default_drag_comp.offsetLeft;
      this.position.y = touch.clientY - default_drag_comp.offsetTop;
      this.dx = touch.clientX;
      this.dy = touch.clientY;
    },
    move(event) {
      event.preventDefault();
      let default_drag_comp = document.querySelector("#default_drag_comp");
      if (this.flags) {
        var touch;
        if (event.touches) {
          touch = event.touches[0];
        } else {
          touch = event;
        }
        this.nx = touch.clientX - this.position.x;
        this.ny = touch.clientY - this.position.y;

        if (this.nx < 0) {
          this.nx = 0;
        } else if (this.nx > this.maxW) {
          this.nx = this.maxW;
        }

        if (this.ny < 0) {
          this.ny = 0;
        } else if (this.ny >= this.maxH) {
          this.ny = this.maxH;
        }

        default_drag_comp.style.left = this.nx + "px";
        default_drag_comp.style.top = this.ny + "px";
        //阻止页面的滑动默认事件；如果碰到滑动问题，1.2 请注意是否获取到 touchmove
        document.addEventListener(
          "touchmove",
          function () {
            // event.preventDefault();
          },
          false
        );
      }
    },
    //鼠标释放时候的函数
    end() {
      this.flags = false;
    },
    goNext2() {
      this.$emit("goNext2");
    },
    // 实现移动端拖拽
    down2() {
      let default_drag_comp = document.querySelector("#default_drag_comp2");
      this.flags2 = true;
      var touch;
      if (event.touches) {
        touch = event.touches[0];
      } else {
        touch = event;
      }
      this.maxW = document.body.clientWidth - default_drag_comp.offsetWidth;
      this.maxH = document.body.clientHeight - default_drag_comp.offsetHeight;

      this.position.x = touch.clientX - default_drag_comp.offsetLeft;
      this.position.y = touch.clientY - default_drag_comp.offsetTop;
      this.dx2 = touch.clientX;
      this.dy2 = touch.clientY;
    },
    move2(event) {
      event.preventDefault();
      let default_drag_comp = document.querySelector("#default_drag_comp2");
      if (this.flags2) {
        var touch;
        if (event.touches) {
          touch = event.touches[0];
        } else {
          touch = event;
        }
        this.nx2 = touch.clientX - this.position2.x;
        this.ny2 = touch.clientY - this.position2.y;

        if (this.nx2 < 0) {
          this.nx2 = 0;
        } else if (this.nx2 > this.maxW) {
          this.nx2 = this.maxW;
        }

        if (this.ny2 < 0) {
          this.ny2 = 0;
        } else if (this.ny2 >= this.maxH) {
          this.ny2 = this.maxH;
        }

        default_drag_comp2.style.left = this.nx2 + "px";
        default_drag_comp2.style.top = this.ny2 + "px";
        //阻止页面的滑动默认事件；如果碰到滑动问题，1.2 请注意是否获取到 touchmove
        document.addEventListener(
          "touchmove",
          function () {
            // event.preventDefault();
          },
          false
        );
      }
    },
    //鼠标释放时候的函数
    end2() {
      this.flags2 = false;
    },
    callPhone() {
      window.location.href = "tel://0512-66555556";
    },
    pushMyOrder() {
      this.$router.push("/order");
    },
    getLogin(){
      console.log(11,this.userInfo)
      // 判断是否高斯登录
      if (this.userInfo && this.userInfo.cosmosUserId!==null) {
        this.loadActivity()
      } else {
        this.$router.replace('/login')
      }
    },
    loadActivity () {
      Activity().then(res => {
        if (res.code === 0) {
          document.title = res.data.name
          this.list = res.data.activityProductVOList
          this.prizeListOrigin = JSON.parse(JSON.stringify(res.data.activityProductVOList))
          this.rule = res.data.rule.replace(/<img/g,"<img style='max-width:100%;height:auto;'");
          this.ruleTxt = res.data.rule
          this.productId = res.data.id
          // // 展示prizes
          const prizes = []
          let text = ''
          this.list.forEach((item, index) => {
            text = `${item.productAttrVOList[0].attributeValue}\n${item.productAttrVOList[1].attributeValue}`
            prizes.push({
              background: '',
              fonts: [{ text: '', top: '10%'}],
              // imgs: [{ src: item.image, height: '30%', top: '55%' }]
            })
          })
          this.prizes = prizes
          // this.defaultConfig.offsetDegree = this.rotateNumber / this.list.length / 2
          yyActivity().then(res => {
            console.log(666,res)
            if(res.code === 0) {
              this.payList = res.data.activityProductVOList
            }
          })
          if (this.userInfo.cosmosUserId) {
            this.loadActivityJoins()
          }
        } else {
          this.$toast(res.msg)
        }
      })
    },
    loadActivityJoins () {
      let data = {
        activityId: process.env.VUE_APP_ACTIVITY_ID2,
        paymentStatus: 'paid'
      }
      let data1 = {
        activityId: process.env.VUE_APP_ACTIVITY_ID,
        paymentStatus: 'paid'
      }
      getApiUserOrderPage(data).then(res=>{
        if(res.code===0){
          console.log(444,res)
          this.payStepList = res.data.list
          if(res.data.list.length===0){
            this.isPay = [false,false]
          }else if(res.data.list.length===1){
            this.isPay = [true,false]
          }else if(res.data.list.length===2){
            this.isPay = [true,true]
          }else{}
        }
      })
      getApiUserOrderPage(data1).then(res=>{
        if(res.code===0){
          this.joinTimes = res.data.list.length
        }
      })
    },
    getPrizesList () {
      const prizes = []
      let data = [
        { name: '1',img: require('../assets/image/i_love.png'),color: '' },
        { name: '2',img: '',color: '' },
        { name: '3',img: require('../assets/image/i_love.png'),color: '' },
        { name: '4',img: '',color: '' },
        { name: '5',img: require('../assets/image/i_love.png'),color: '' },
        { name: '6',img: '',color: '' },
      ]
      data.forEach((item, index) => {
        prizes.push({
          name: item.name,
          background: item.color,
          fonts: [{ text: '', top: '10%'}],
          // imgs:[
          //   { src: require('../assets/image/i_market.png'), width: '100', top: '-10'},
          //   { src: item.img, width: '80',height: '80', top: '10'}
          //   ],
        })
      })
      this.prizes = prizes
    },
    startCallBack () {
      if(this.isPay[0]===false || this.isPay[1]===false){
        this.$toast('当前没有抽奖机会')
        return
      }
      if(this.starting===false){
        this.starting = true
        this.loadLottery()
      }
      // this.$router.push("/mtl");
      // this.$refs.LuckyWheel.play()
      // setTimeout(() => {
      //   this.$refs.LuckyWheel.stop(Math.random() * 8 >> 0)
      // }, 2000)
    },
    loadLottery () {
      Lottery().then(res => {
        if (res.code === 0) {
          let r
          for(let i =0;i<res.data.activityProductVOList.length;i++){
            if(res.data.activityProductVOList[i].id===res.data.productId){
              this.lotteryItem = res.data.activityProductVOList[i]
              r = i
            }
          }
          this.onClickRotate(r)
          // this.$refs.LuckyWheel.play()
          // setTimeout(() => {
          //   this.$refs.LuckyWheel.stop(Math.random() * 8 >> 0)
          // }, 2000)
          // const data = {
          //   activityId: res.data.activityId,
          //   orderId: res.data.orderId
          // }
          // const _this = this
          // createLotteryOrder(data).then(r => {
          //   if (r.code === 0) {
          //     // this.prizeMsg = r
          //   } else {
          //     // this.$refs.LuckyWheel.stop(_this.currentIndex)
          //     this.$toast(r.msg)
          //   }
          // })
        } else {
          this.starting = false
          this.$toast(res.msg)
        }
      })
    },
    endCallBack () {
      // alert(`ca !!!!! ${prize.title}`)
      // recharge 直冲
      // card  卡密
      // material  实物
      // chance    机会 谢谢参与
      // wxRedPacket  微信红包
      // wxDiscountAmount   微信立减金
      this.starting = false
      if (this.lotteryItem.productCategoryType === 'chance') {
        // 谢谢参与
        this.modalFailShow = true
      } else {
        this.modalGetShow = true
      }
    },
    getPrize () {
      this.modalGetShow = false
    },
    payOrder(i){
      console.log(111,i,this.payList)
      if(this.payList.length===0){
        this.$toast('活动太火爆，请稍后再试')
        return
      }
      if(i===1 && this.isPay[0] === false){
        this.$toast('请先预约再搭乘')
        return
      }
      if (this.payList[i].stock - this.payList[i].sale <= 0) {
        this.$toast('商品太火爆，补货中')
        return
      }
      if (i===1 && this.isPay[0] === true && this.nowTime <= this.payStepList[0].createTime.split(' ')[0]) {
        this.$toast('预约成功，请明日过来搭乘，并领取搭乘礼品')
        return
      }
      if (i===1 && this.isPay[0] === true && this.nowTime > '2021-12-31') {
        this.$toast('活动已截止')
        return
      }
      var order = {
        productId: this.payList[i].id,
        quantity: 1
      }
      // console.log(order);
      Order(order).then(res => {
        if (res.code === 0) {
          console.log(res, "7878")
          // window.localStorage.setItem("orderId", res.data.orderId)
          // this.$router.push({
          //   path: "/purchase",
          //   query: { data: JSON.stringify(res.data) }
          // })
          this.getCheckOrder(res.data.orderId)
        } else {
          this.$toast(res.msg)
        }
      })
    },
    async getCheckOrder(orderId) {
      console.log('进入了')
      var order = {
        orderId: orderId,
      };
      localStorage.setItem('sjhb_orderId', orderId)
      checkOrder(order).then(res => {
        if (res.code == 0) {
          var orderstatus = res.data.paymentStatus;
          if (orderstatus == "paid") {
            this.$toast("订单已支付");
          } else {
            this.purchase(orderId)
          }
        } else {
          this.$toast(res.msg);
        }
      })
    },
    async purchase(orderId) {
      var data = {
        orderId: orderId,
        payChannelId: "21",
        redirectUrl: window.location.href.split("?")[0],
        payExtra: JSON.stringify({
          pay_id: "25",
          channel_redirect_url: window.location.href.split("?")[0]
        })
      };
      // console.log(resp.data, "66ß");
      Pay(data).then(resp => {
        if (resp.data.code === 0) {
          const div = document.createElement("div");
          div.innerHTML = resp.data.data.builder;
          document.body.appendChild(div);
          document.forms.paysubmit.submit();
        } else {
          this.$toast(resp.data.msg);
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .index {
    position: relative;
  }
  .index-order {
    position: fixed;
    top: 300px;
    right: 20px;
    width: 90px;
    height: 90px;
    padding: 14px 0 0 0;
    background: linear-gradient(0deg, #f2490e 0%, #fdc919 99%);
    box-shadow: 1px 14px 54px 0px rgba(213, 84, 10, 0.49);
    border-radius: 50%;
    opacity: 0.9;
    z-index: 2000;
  }
  .index-order img {
    display: block;
    width: 28px;
    height: 31px;
    margin: 0px auto 2px;
  }
  .index-order div {
    text-align: center;
    font-size: 18px;
    color: #ffffff;
  }
  .index-kefu {
    position: fixed;
    right: 30px;
    top: 520px;
    width: 90px;
    height: 90px;
    padding: 14px 0 0 0;
    border-radius: 50%;
    opacity: 0.9;
    z-index: 2000;
    display: none;
  }
  .index-kefu img {
    display: block;
    width: 90px;
    height: 90px;
    margin: 12px auto 2px;
  }
  .index-kefu div {
    text-align: center;
    font-size: 18px;
    color: #ffffff;
  }
  .index-shoplist{
    .btn{
      width: 100%;
      height: 110px;
      background: linear-gradient(0deg,#de6621 0%, #fe8641 100%);
      box-shadow: 0 -5px 6px 0 rgba(210,210,210,0.20);
      position: fixed;
      left: 0;
      bottom: 0;
      color: #ffffff;
      text-align: center;
      line-height: 110px;
      font-size: 36px;
      &.gray{
        background: #999;
      }
    }
  }
  .index-list{
    padding-bottom: 80px;
    img{
      width: 100%;
      display: block;
    }
  }
  .rule-box{
    position: fixed;
    top: 200px;
    right: 0;
    z-index: 99;
    /*width: 96px;*/
    height: 60px;
    padding: 0 20px;
    background: rgba(0,0,0,.6);
    border-top-left-radius: 60px;
    border-bottom-left-radius: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    .r-icon{
      display: block;
      width: 30px;
      height: 30px;
      margin-right: 8px;
    }
    .r-txt{
      font-size: 26px;
      color: #fff;
    }
  }
</style>
<style lang="less" scoped>
  .wtop-box{
    width: 100%;
    /*height: 1043px;*/
    position: relative;
    .wbImg{
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: -335px;
      width: 250px;
    }
    .wheel-box{
      position: absolute;
      bottom: 350px;
      left: 50%;
      transform: translateX(-50%);
      /*width: 310px;*/
      /*height: 310px;*/
      .wheel-inner{
        position: relative;
      }
      .luck-draw {
        width: 270px;
        height: 270px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%)
      }
    }
    .img-box{
      position: absolute;
      top: -270px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 10;
      .img-inner{
        position: relative;
        width: 180px;
        height: 180px;
        .img1{
          width: 180px;
          height: 180px;
        }
        .img2{
          position: absolute;
          top: 50px;
          left: 50%;
          transform: translateX(-50%);
          width: 80px;
          height: 80px;
        }
      }
    }
    .img-box2{
      left: 120px;
      transform: translateX(0);
      top: -130px;
    }
    .img-box3{
      left: -300px;
      transform: translateX(0);
      top: -130px;
    }
    .img-box4{
      left: -300px;
      transform: translateX(0);
      top: 80px;
    }
    .img-box5{
      left: 120px;
      transform: translateX(0);
      top: 80px;
    }
    .img-box6{
      left: 50%;
      transform: translateX(-50%);
      top: 205px;
    }
    .bgImg{
      /*position: absolute;*/
      /*top: 0;*/
      /*left: 0;*/
      width: 100%;
      height: auto;
    }
    .wt-order{
      position: absolute;
      top: 369px;
      right: 0;
      /*width: 127px;*/
      height: 50px;
      opacity: 1;
      background: #f7333a;
      border-radius: 40px 0 0 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 0 11px 0 13px;
      color: #FFFFFF;
      font-size: 20px;
      img{
        width: 30px;
        height: auto;
        opacity: 1;
        margin-right: 5px;
      }
    }
  }
  .wheel-rules{
    width: 682px;
    /*height: 1042px;*/
    opacity: 1;
    background: linear-gradient(0deg,#fffbe4 0%, #f84b48 99%);
    border-radius: 20px;
    margin: 31px auto 0 auto;
    padding-bottom: 22px;
    .wr-title{
      height: 104px;
      line-height: 104px;
      text-align: center;
      color: #FEFBF2;
      font-size: 36px;
      margin: 0 auto;
    }
    .wr-content{
      width: 646px;
      opacity: 1;
      background: #fefbf2;
      border-radius: 18px;
      box-sizing: border-box;
      padding: 34px;
      margin: auto;
      padding-bottom: 22px;
      /*/deep/ strong{*/
      /*  font-size: 24px;*/
      /*}*/
      /*p{*/
      /*  margin: 0;*/
      /*  padding: 0;*/
      /*  color: #333;*/
      /*  font-size: 24px;*/
      /*  line-height: 48px;*/
      /*}*/
      /*.wrc-p{*/
      /*  box-sizing: border-box;*/
      /*  padding-left: .5em*/
      /*}*/
    }
  }
  .wheel-tips{
    width: 682px;
    box-sizing: border-box;
    padding: 25px 18px;
    opacity: 1;
    background: linear-gradient(0deg,#fffbe4 0%, #f84b48 99%);
    border-radius: 20px;
    margin: auto;
    .wt-inner{
      width: 100%;
      opacity: 1;
      background: #fefbf2;
      border-radius: 18px;
      box-sizing: border-box;
      padding: 38px 45px 30px 45px;
      .w-box{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 55px;
        .w-line{
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          font-size: 0;
          .wl-btn{
            width: 177px;
            height: 47px;
            opacity: 1;
            background: #fdc772;
            border-radius: 24px;
            margin-top: 19px;
            color: #B47317;
            font-size: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .gray{
            background: #dedede;
            color: #B8B8B8;
          }
          .wl-top{
            width: 255px;
            height: 134px;
            opacity: 1;
            background: linear-gradient(0deg,#FFE8CF 0%, #ffeed9 100%);
            border-radius: 24px;
            position: relative;
            .wlt-num{
              position: absolute;
              width: 63px;
              height: 35px;
              top: 15px;
              left: 15px;
            }
            .wlt-love{
              position: absolute;
              top: -50px;
              right: -48px;
              width: 167px;
              height: 160px;
              opacity: 1;
              /*background: rgba(220,220,220,0.45);*/
              /*box-shadow: 0px 10px 40px 0px rgba(221,130,32,0.19);*/
            }
            .wlt-price{
              position: absolute;
              left: 0;
              bottom: 21px;
              width: 100%;
              text-align: center;
              color: #666666;
              font-size: 24px;
              span{
                color: #FF4E0F;
              }
            }
          }
        }
      }
      .w-tips{
        border-top: 1px solid#FFE1C2;
        line-height: 48px;
        color: #333333;
        font-size: 24px;
        padding: 25px 20px 0 20px;
        span{
          color: #F7333A;
        }
      }
    }
  }

.prize-wrapper{
  /*高度去除*/
  /*height: 1570px;*/
  background: #fff;
  position: relative;
  padding-bottom: 40px;
  overflow: hidden;
  .prize-order-box{
    position: fixed;
    top: 304px;
    right: 0;
    z-index: 99;
    height: 44px;
    width: 130px;
    background: #ff4266;
    border-top-left-radius: 44px;
    border-bottom-left-radius: 44px;
    font-size: 24px;
    box-shadow: 0 3px 7px 0 rgba(210,71,24,0.35);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    .txt{
      line-height: 1.2;
    }
  }
  .call {
    position: fixed;
    top: 480px;
    right: 20px;
    width: 88px;
    height: 88px;
    z-index: 99;
    img {
      width: 88px;
      height: 88px;
    }
  }
  .p-bg{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 0;
  }
  .prize-main-content{
    position: relative;
    padding-top: 290px;
    padding-bottom: 60px;
    .p-m-title{
      font-size: 24px;
      color: #fff;
      background: rgba(141,52,40,.2);
      height: 44px;
      border-radius: 44px;
      display: flex;
      width: 350px;
      margin: 0 auto;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .p-box{
      width: 652px;
      height: 652px;
      margin: 0 auto;
      position: relative;
      .pan{
        display: block;
        width: 100%;
        height: 100%;
      }
      .luck-wheel-box{
        position: absolute;
        left: 50.4%;
        top: 51%;
        transform: translate(-50%,-50%);
        /*border: 2px solid red;*/
        box-sizing: border-box;
        /*width: 520PX;*/
        /*height: 520PX;*/
        width: 520px;
        height: 520px;
      }
      .p-btn{
        position: absolute;
        width: 200px;
        height: 234px;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        .start{
          display: block;
          width: 100%;
          height: 100%;
        }
      }
    }
    .rule-box{
      margin: 146px auto 0;
      width: 718px;
      background: #fff2da;
      border: 2px solid #fbd5ab;
      padding: 10px;
      border-radius: 20px;
      .inner{
        padding: 20px 20px 30px;
        border: 2px solid #fbd6ac;
        border-radius: 20px;
        .r-title{
          display: flex;
          /*align-items: center;*/
          justify-content: center;
          margin-bottom: 4px;
          .r-icon{
            display: block;
            width: 55px;
            height: 57px;
            margin-right: 4px;
          }
          .r-txt{
            font-size: 30px;
            color: #8d3428;
          }
        }
        .r-content{
          font-size: 24px;
          color: #8d3428;
          .r-line{
            display: flex;
            .r-label{
              width: 170px;
            }
            .r-right{
              flex: 1;
              min-width: 0;
            }
          }
        }
      }
    }
  }
}
.van-popup.get-modal{
  background: transparent;
  width: 100%;
  .get-modal-box{
    width: 631px;
    height: 840px;
    margin: 0 auto;
    position: relative;
    .get-bg{
      position: absolute;
      z-index: 0;
      left: 0;
      right: 0;
      display: block;
      width: 631px;
      height: 840px;
    }
    .label-bg{
      position: absolute;
      z-index: 1;
      left: -58px;
      top: -40px;
      width: 730px;
      height: 514px;
    }
    .get-modal-content{
      position: relative;
      z-index: 9;
      width: 100%;
      height: 100%;
      padding: 40px 40px 50px;
      .top{
        padding: 40px 20px 40px;
        .img-box{
          margin: 0 auto;
          width: 360px;
          height: 170px;
          position: relative;
          .product{
            position: absolute;
            max-height: 100%;
            max-width: 100%;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        }
        .top-title{
          text-align: center;
          font-size: 36px;
          color: rgba(141,52,40,1);
          margin-bottom: 30px;
          margin-top: 25px;
          .price{
            font-style: normal;
            /*font-size: 77px;*/
            font-size: 60px;
            color: rgba(235,26,66,1);
            /*margin: 0 18px;*/
            margin: 0;
          }
        }
        .top-btn-box{
          width: 214px;
          height: 70px;
          margin: 0 auto;
          background: linear-gradient(0deg,#e70025 0%, #ff375d 100%);
          border-radius: 12px;
          box-shadow: 0 3px 7px 0 rgba(210,71,24,0.35), 0 3px 7px 0 rgba(255,255,255,0.48) inset;
          text-align: center;
          font-size: 30px;
          color: #fff;
          line-height: 70px;
          position: relative;
          .t-icon{
            position: absolute;
            display: block;
            width: 59px;
            height: 60px;
            right: -10px;
            top: -30px;
          }
        }
      }
      .info{
        padding: 0 20px;
        height: 300px;
        color: rgba(250,209,139,1);
        display: flex;
        /*align-items: center;*/
        justify-content: center;
        flex-direction: column;
        .info-title{
          font-size: 30px;
          margin-bottom: 16px;
        }
        .info-txt{
          font-size: 24px;
          line-height: 38px;
          height: 146px;
          overflow-y: auto;
        }
      }
    }
  }
  .get-modal-close-box{
    margin: 0 auto;
    width: 86px;
    height: 86px;
    .close{
      display: block;
      width: 86px;
      height: 86px;
    }
  }
}
.van-popup.fail-modal{
  background: transparent;
  width: 100%;
  .get-modal-box{
    width: 689px;
    height: 671px;
    margin: 0 auto;
    position: relative;
    .get-bg{
      position: absolute;
      z-index: 0;
      left: 0;
      right: 0;
      display: block;
      width: 689px;
      height: 671px;
    }
    .label-bg{
      position: absolute;
      z-index: 1;
      left: -30px;
      top: 10px;
      width: 714px;
      height: 301px;
    }
    .line{
      position: absolute;
      z-index: 2;
      width: 2px;
      height: 62px;
      background: linear-gradient(0deg,#d91d1d 0%, #fc5b40 97%);
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
    .get-modal-content{
      position: relative;
      z-index: 9;
      width: 100%;
      height: 100%;
      padding: 40px 40px 50px;
      .top{
        padding: 40px 20px 40px;
        .img-box{
          margin: 0 auto;
          width: 360px;
          height: 170px;
          position: relative;
          .product{
            position: absolute;
            /*max-height: 100%;*/
            /*max-width: 100%;*/
            width: 126px;
            height: 127px;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        }
        .top-title{
          text-align: center;
          font-size: 36px;
          color: rgba(141,52,40,1);
          margin-bottom: 30px;
          .price{
            font-style: normal;
            font-size: 77px;
            color: rgba(235,26,66,1);
            margin: 0 18px;
          }
        }
        .top-btn-box{
          width: 214px;
          height: 70px;
          margin: 0 auto;
          background: linear-gradient(0deg,#e70025 0%, #ff375d 100%);
          border-radius: 12px;
          box-shadow: 0 3px 7px 0 rgba(210,71,24,0.35), 0 3px 7px 0 rgba(255,255,255,0.48) inset;
          text-align: center;
          font-size: 30px;
          color: #fff;
          line-height: 70px;
          position: relative;
          .t-icon{
            position: absolute;
            display: block;
            width: 59px;
            height: 60px;
            right: -10px;
            top: -30px;
          }
        }
      }
    }
  }
  .get-modal-close-box{
    margin: 0 auto;
    width: 86px;
    height: 86px;
    .close{
      display: block;
      width: 86px;
      height: 86px;
    }
  }
}
.van-popup.bill-modal{
  background: transparent;
  width: 100%;
  .bill-modal-box{
    width: 80%;
    margin: 0 auto;
    position: relative;
    padding: 50px;
    background: #fff;
    border-radius: 20px;
    .bill-label{
      font-size: 48px;
      color: #000;
      margin-bottom: 30px;
    }
    .bill-input-box{
      padding: 50px 0;
      border-bottom: 2px solid #dadada;
      margin-bottom: 98px;
      .bill-input{
        border: none;
        outline: none;
        font-size: 48px;
        font-weight: bold;
        color: #000;
        display: block;
        width: 100%;
      }
    }
    .bill-mini-label{
      font-size: 30px;
      font-weight: 600;
      color: #999;
      margin-bottom: 20px;
    }
    .bill-money{
      width: 200px;
      height: 150px;
      line-height: 150px;
      font-size: 48px;
      font-weight: 600;
      color: #fff;
      text-align: center;
      background: #0ac160;
      border-radius: 8px;
      box-shadow: 1px 8px 19px 2px rgba(9,193,95,0.28);
      margin-bottom: 98px;
    }
  }
}
  .van-popup.rule-modal {
    box-sizing: border-box;
    width: 90%;
    height: 80%;
    overflow-y: auto;
    border-radius: 20px;
    color: #333333;
    padding: 50px 30px 20px 25px;
    text-align: left;
    .title {
      text-align: center;
      font-size: 34px;
      font-weight: 700;
      margin-bottom: 20px;
    }
    .content{
      img{
        display: block;
        max-width: 100%;
      }
      /deep/ img{
        display: block;
        max-width: 100%;
      }
    }
    &.service-modal{
      width: 60%;
      height: auto;
      padding: 30px;
    }
    .service-list{
      .service{
        display: flex;
        align-items: center;
        padding-bottom: 36px;
        img{
          width: 56px;
          height: 56px;
          display: inline-block;
          margin-right: 21px;
        }
        font-size: 30px;
        color: #333333;
        font-weight: bold;
        &.time{
          padding-top: 20px;
          padding-bottom: 10px;
          display: block;
          font-weight: normal;
          font-size: 24px;
          border-top: 1px dashed #666666;
          .title{
            display: block;
            font-size: 30px;
            text-align: left;
            padding-top: 15px;
          }
        }
      }
    }
  }
  .wheel-wrapper {
    width: 500px;
    height: 500px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .wheel-pointer {
      width: 120px;
      height: 120px;
      border-radius: 1000px;
      /*background: yellow;*/
      position: absolute;
      left: 50%;
      top: 45%;
      transform: translate(-50%, -50%);
      text-align: center;
      line-height: 60px;
      z-index: 10;
      .wp-inner{
        position: relative;
        width: 120px;
        height: 120px;
      }
      img{
        width: 120px;
        /*height: 120px;*/
      }
      .wp-start{
        position: absolute;
        top: 68%;
        left: 50%;
        width: 80px;
        transform: translateY(-50%) translateX(-50%);
      }
      .hand-box{
        position: absolute;
        top: 73%;
        left: 40%;
        transform: translateY(-50%) translateX(-50%);
        width: 80px;
        height: 80px;
        z-index: 1;
        animation: handAnimate 0.3s linear infinite;
        .h-icon{
          display: block;
          width: 100%!important;
          height: 100%;
        }
      }
    }
    .wheel-bg {
      width: 100%;
      height: 100%;
      border-radius: 1000px;
      /*overflow: hidden;*/
      /*transition: transform 3s ease-in-out;*/
      transition: transform 6s;
      /*background: #7EEF97;*/
      background: url('../assets/image/w-border.png')no-repeat;
      background-size: 100% 100%;
      position: relative;

      &.freeze {
        transition: none;
        background: red;
      }
    }

    .prize-list {
      width: 100%;
      height: 100%;
      position: relative;
      text-align: center;
    }

    .prize-item-wrapper {
      position: absolute;
      top: -10px;
      left: 32%;
      transform: translateX(-50%);
      width: 180px;
      height: 180px;
      z-index: 10;
      transform-origin: 49% 14%;
      /*transform-origin: top center;*/
      transition: all 6s;
    }
    .mm1{
      left: 370px;
      top: 110px;
    }
    .mm2{
      left: 370px;
      top: 340px;
    }
    .mm3{
      top: 460px;
    }
    .mm4{
      left: -50px;
      top: 340px;
    }
    .mm5{
      left: -50px;
      top: 110px;
    }
    .prize-item {
      width: 100%;
      height: 100%;
      transform-origin: bottom;

      .prize-name {
        font-size: 0;
        height: 180px;
        position: relative;
        img{
          width: 180px;
          height: 180px;
        }
        .pImg{
          position: absolute;
          width: 70px;
          height: 70px;
          top: 50%;
          left: 50%;
          transform: translateX(-50%) translateY(-50%);
        }
      }

      .prize-icon {}
    }
  }
  @keyframes handAnimate {
    0%{
      /*left: 368px;*/
      transform: scale(1);
    }
    25%{
      /*left: 366px;*/
      transform: scale(1.1);
    }
    50%{
      /*left: 364px;*/
      transform: scale(1.2);
    }
    75%{
      /*left: 366px;*/
      transform: scale(1.1);
    }
    100%{
      /*left: 368px;*/
      transform: scale(1);
    }
  }
</style>
